<template>
	<nav
		class="app-header navbar is-fixed-top gtm-header"
		:class="headerClass"
		role="navigation"
		aria-label="main navigation"
	>
		<div class="navbar-brand">
			<slot name="brand"></slot>
			<div
				:class="{ 'is-active': showNav }"
				class="navbar-burger burger"
				data-target="navMenu"
				@click="showNav = !showNav"
			>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>

		<div class="navbar-menu" :class="{ 'is-active': showNav }">
			<div class="navbar-start">
				<slot name="navigation"></slot>
			</div>
			<div class="navbar-end">
				<div class="navbar-item">
					<div v-if="impersonating" class="impersonating">
						<dc-icon icon="exclamation-circle" library="far" size="lg"></dc-icon
						>You're temporarily logged in as this user. When you're done, log
						out
					</div>
				</div>
				<slot name="logo"></slot>
				<div class="navbar-item has-dropdown" :class="{ 'is-active': active }">
					<a
						v-if="currentUser !== null"
						v-click-outside="onClickOutside"
						class="navbar-link user-avatar"
						@click.stop="toggle"
					>
						<avatar
							:image="currentUser.image"
							:alt="fullName"
							:cropped="true"
							size="is-32x32"
							is-rounded
							class="header-avatar mr-2"
						/>
						{{ fullName }}
					</a>
					<div class="navbar-dropdown">
						<span @click="close">
							<router-link
								:to="profilelink"
								class="navbar-item gtm-view-logged-in-user-profile"
							>
								Profile
							</router-link>
						</span>
						<hr v-if="helpLink" class="navbar-divider" />
						<a
							v-if="helpLink"
							:href="helpLink"
							class="navbar-item gtm-help-link"
							target="_blank"
						>
							Help
						</a>
						<hr class="navbar-divider is-hidden-tablet" />
						<a
							class="navbar-item gtm-send-us-message is-hidden-tablet"
							@click="newMessage"
						>
							Send us a message
						</a>
						<hr class="navbar-divider" />
						<a class="navbar-item gtm-log-out" @click="logout"> Logout </a>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
import vClickOutside from "v-click-outside";
import Avatar from "../components/AppAvatar";
import { mapActions } from "vuex";
export default {
	name: "LayoutHeaderBar",
	components: { Avatar },
	directives: {
		clickOutside: vClickOutside.directive
	},
	props: {
		helpLink: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			showNav: false,
			active: false
		};
	},
	computed: {
		fullName() {
			return this.currentUser.firstname + " " + this.currentUser.lastname;
		},
		headerClass() {
			return `is-${process.env.VUE_APP_RELEASE_STAGE.toLowerCase()}`;
		},
		profilelink() {
			return { name: "profile.index" };
		},
		impersonating() {
			return !!window.localStorage.getItem("impersonation");
		}
	},
	watch: {
		$route() {
			this.showNav = false;
		}
	},
	methods: {
		...mapActions({
			logout: "userModule/logout",
			newMessage: "intercomModule/message"
		}),
		close() {
			this.showNav = false;
		},
		toggle() {
			this.active = !this.active;
		},
		onClickOutside() {
			this.active = false;
		}
	}
};
</script>

<style scoped>
.router-link-exact-active {
    color: #485fc7;
    border-bottom: 2px solid #485fc7;
}

</style>

<style lang="scss">
.navbar-item, .navbar-link {
    font-size: .9375rem;
    font-weight: 600;
}

.app-header {
	box-shadow: 0 2px 3px #1111111a, 0 0 0 1px #1111111a;
	&.is-local {
		background-color: lighten($colour-yellow, 10%);
	}
	&.is-development {
		background-color: lighten($colour-navy, 50%);
	}
	&.is-staging {
		background-color: $colour-light-grey;
	}
	.user-avatar {
		display: none;

		@include widescreen {
			display: flex;
		}
	}
}
</style>
